<template>
	<div class="">
		<!-- 根据客户显示按钮包括：1、解绑 2、类别修改 3、选择公司 4、添加终端 5、移除终端 -->
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">网关配置</h1>
			<div class="clear marBottom20">				
				<choose-company @event1="changeCom($event)" :areaFlag="areaFlag"></choose-company>
			</div>
			<div class="search-box search-box3">
		  		<!--<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>-->
				<input placeholder="请输入要搜索的mac地址" @keyup.enter="searchByMac()" v-model="mac_address" class="log-input search-input" />
				<el-button @click="searchByMac()"> 搜 索 </el-button>
			</div>
			<el-table
		    	stripe
				border		    	
			    ref="multipleTable"
			    :data="cDevList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="device_name"
			      label="网关名称">
			    </el-table-column>
			    <el-table-column
			      prop="device_type"
			      label="网关类型"
			      :formatter="deviceTypeFormat"
			      show-overflow-tooltip
				  width="100">
			    </el-table-column>
			    <el-table-column
			      prop="mac_address"
			      label="MAC地址"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="equipment_staus"
			      label="状态"
			      width="100">
			    </el-table-column>
				<el-table-column
			      prop="category"
			      label="类别"
				  :formatter="deviceTypeFormat2"
			      width="100">
			    </el-table-column>
			    <el-table-column
			      prop="company"
			      label="所属公司"
			      v-if="administrators==3 || administrators==5"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="created_time"
			      label="创建时间"
			      :formatter="dateFormat"
				  width="100">
			    </el-table-column>
			    <el-table-column
					width="210"
		          label="操作"
		          show-overflow-tooltip>
		          <template slot-scope="scope">
		          	<el-button type="text" size="small"
		                       @click="toTerminalDev(scope.$index, scope.row)"> 终端管理 
		            </el-button>		            
		            <el-button type="text" size="small"
		                       @click="clickChangeName(scope.$index, scope.row)"> 更名 
		            </el-button>
		            <el-button type="danger" size="small" v-if="scope.row.is_def==1"
		                       @click="changeDef(scope.$index, scope.row, 2)"> 撤防 
		            </el-button>
		            <el-button type="text" size="small" v-if="scope.row.is_def==2"
		                       @click="changeDef(scope.$index, scope.row, 1)"> 布防 
		            </el-button>
					<el-button type="text" size="small" v-if="unbindBtn"
		                       @click="unbindClick(scope.$index, scope.row)"> 解绑 
		            </el-button>
					<el-button type="text" size="small" v-if="changeTypeBtn"
		                       @click="showType(scope.row)"> 类别修改 
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
	  			<br />
				<div class="text-right">
					<el-pagination
						@current-change="handleCurrentChange"
					  :page-size="pagesize"
					  layout="total, prev, pager, next"
					  :total="totalNum">
					</el-pagination>
				</div>
		</div>
		<!--解除绑定-->
		<el-dialog title="解除绑定" :visible.sync="unbindAdminFlag" width="500px">
        
	        <el-form>
	        	<el-form-item label="名称" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.device_name"></span>
			    </el-form-item>
	            <el-form-item label="MAC地址" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.mac_address"></span>
			    </el-form-item>
			    <el-form-item label="所属公司" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.company"></span>
			    </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="unbindAdminFlag=false">取消</el-button>
	          <el-button type="primary" @click="unbindAdmin()">确定</el-button>
	        </div>
	    </el-dialog>
	    <!--网关名称编辑框-->
		<el-dialog title="网关更名" :visible.sync="devDialogFlag" width="500px" >
		    <el-form>
	        	<el-form-item label="名称" label-width="80px">
			    	<el-input v-model="changeNameDev.device_name" auto-complete="off"></el-input>
			    </el-form-item>
	            
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancelChangeName()">取消</el-button>
			    <el-button type="primary" @click="confirmChangeDevName()">确定</el-button>
			  </div>
		</el-dialog>
		<!--网关类别编辑框-->
		<el-dialog title="类别修改" :visible.sync="typeFlag" width="500px" >
		    <el-form>
	        	<el-form-item label="类别" label-width="80px">
			    	<el-select class="ml20" v-model="category" placeholder="请选择类别">
						<el-option v-for="(type,index) in typeList" :label="type.value" :key="index" :value="type.id"></el-option>
					</el-select>
			    </el-form-item>
	            
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="typeFlag=false">取消</el-button>
			    <el-button type="primary" @click="changeType()">确定</el-button>
			  </div>
		</el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>
</template>

<script>
	import chooseCompany from './../comss/chooseCompany.vue'
	export default {
		components: {
			chooseCompany
		},
		mounted() {
			this.$nextTick(function(){
				this.getBtns();					
				this.getDeviceList();	
						
		  	})
    	},
    	data(){
    		return{
				// 选择公司区域参数
				areaFlag: 3,
    			cDevList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			comList:[],
    			selectComId:null,
    			selectCom:{},
    			selectAreaId:null,
    			areaList:[],
    			mac_address:"",
    			unbindAdminFlag:false,
    			formLabelWidth:"120px",
    			unbindDevice:{},
    			showLoading:false,
    			administrators:this.getCookie('administrators'),
    			devDialogFlag:false,
    			beforName:"",
    			changeNameDev:{
		  			device_name:""
				  },
				// 按钮数据
				changeTypeBtn: false,
				unbindBtn: false,
				addTerminalBtn: false,
				removeTerminalBtn: false,
				// 网关类别
				editDev: null,
				typeFlag: false,
				category: 1,
				typeList:[
					{
						id: 1,
						value: "机柜"
					},
					{
						id: 2,
						value: "动力"
					},
					{
						id: 3,
						value: "环境"
					},
				]

    		}
    	},
    	methods:{
			// 修改类别
			showType(row){
				this.typeFlag = true;
				this.editDev = row;
				this.category = this.editDev.category || 1;
			},
			// 获取按钮列表
			getBtns(){				
		  		let valiCodeParams={
					uid:this.getCookie('uid'),
					role_id: this.getCookie('administrators'),
					owerid: this.getCookie('currentMenuId'),
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/RoleAction/roleMenuButtons",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
						let btns = res.data.data || [];
						if(btns.length){
							btns.map(item=>{
								if(item.name=='类别修改'){
									this.changeTypeBtn = true;
								}
								if(item.name=='解绑'){
									this.unbindBtn = true;
								}
								if(item.name=='添加终端'){
									this.addTerminalBtn = true;
								}
								if(item.name=='移除终端'){
									this.removeTerminalBtn = true;
								}								
							})
						}
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			changeType(){				
		  		let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id: this.editDev.id || "",
					category: this.category || "",
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceManage/DeviceCategory",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
						this.typeFlag = false;
		        		this.$message.success(res.data.msg);
		        		this.getDeviceList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},			
			// 父子通讯
			changeCom(data){
				this.selectComId = data.selectComId || "";
				this.selectAreaId = data.selectAreaId || "";			
			},
			// 选择公司及区域后调用方法
			toChooseCompanyMethod(){
				this.getDeviceList();
			},
    		toTerminalDev(index,row){
				let routeUrl = this.$router.resolve({
			          path: "/device/terminalDevice",
			          query: {
			          	id:row.id,
						device_name:row.device_name,
						addTerminalBtn: this.addTerminalBtn,
						removeTerminalBtn: this.removeTerminalBtn
			          }
			     });
			     window.open(routeUrl.href, '_blank');
			},
//			点击更名
			clickChangeName(index,row){
				this.changeNameDev = row;
				this.beforName= row.device_name;
				this.devDialogFlag = true;
			},
			//取消编辑名称
			cancelChangeName(){
				this.devDialogFlag = false;
				this.changeNameDev.device_name = this.beforName;
			},
    		getDeviceList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
					mac_address:this.mac_address,
					company_id:this.selectComId || "",
					packet_id:this.selectAreaId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceManage/DeviceList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.cDevList = res.data.data.datalist || [];
		        			this.totalNum = res.data.data.totalNumber;
		        		}	        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		this.mac_address = "";		  		
			},
//			确认修改网关名称
			confirmChangeDevName(){
				let devNameParams={
					uid:this.getCookie('uid'),
					device_id: this.changeNameDev.id,
					device_name: this.changeNameDev.device_name,
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign(devNameParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/EquipmentSave/EquipmentSave",this.$qs.stringify(devNameParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.devDialogFlag = false;
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
//			根据MAC地址搜索
			searchByMac(){
				this.selectComId = null;
				this.selectAreaId = null;
				this.getDeviceList();
			},
//			修改布防状态
			changeDef(index,row,num){
				let changeDefParams={
					uid: this.getCookie('uid'),
					device_id: row.id,
					is_def: num,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(changeDefParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceManage/DeviceIsDef",this.$qs.stringify(changeDefParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		setTimeout(()=>{
		        			this.getDeviceList();
		        		},500)
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			点击解绑
			unbindClick(index,row){
				this.unbindAdminFlag = true;
				this.unbindDevice = row;
			},
//			确认解绑
			unbindAdmin(){
				this.unbindAdminFlag = false;
				this.showLoading = true;
				let valiCodeParams={
					uid: this.getCookie('uid'),
					device_id: this.unbindDevice.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceManage/DeviceUnbind",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		setTimeout(()=>{
		        			this.getDeviceList();
		        		},500)
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
		  		
			}
    	}
   }
</script>

<style>
	.search-box3{
		margin-top: -88px;
	}
</style>


// WEBPACK FOOTER //
// src/components/device/collectDevice.vue